export const getCandidateLatestWorkExperience = (resume: Resume): string => {
  const latestExperience = resume.work_experiences?.[0];
  return latestExperience
    ? `${latestExperience.job_role} @ ${latestExperience.company_name}`
    : 'No work experience';
};

export const getCandidateFullName = (firstName: string, lastName: string): string => {
  return lastName === '' ? firstName : `${firstName} ${lastName}`;
};
